import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

function* loginUserFn() {
  try {
    const responseFromAPI = yield call(loginUser, user);
    if (responseFromAPI.code === 200) {
      const { data, tokens } = responseFromAPI;
      yield put(loginSuccess({ data, tokens }));
    } else {
      const {
        response: { data = null },
      } = responseFromAPI;
      yield put(apiError(data));
    }
  } catch (error) {
    console.log("error", error);
    yield put(apiError(error));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser");

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout);
      yield put(logoutUserSuccess(response));
    }
    history("/login");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeLatest(LOGIN_USER, loginUserFn);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
